module.exports = __webpack_public_path__ + "doctor2.dde3ba43035c67749f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor2.png
// module id = 452
// module chunks = 1